import React, { useEffect, useState } from 'react';
import { AutocompleteInput } from '../../Helpers/Inputs';
import PropTypes from 'prop-types';
import * as yup from 'yup';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import { makeStyles } from "@material-ui/core/styles";
import { Row, Col, Form } from 'react-bootstrap';
import { Button } from '@material-ui/core';
import { customValidators } from "../../Helpers/Validators/customValidators";
import './CaseFilters.scss';
import { TextInput, DropdownInput } from '../../Inputs/FormInputs';
import { useForm } from 'react-hook-form';
import States from '../../Helpers/Lists/States';
import { InputMaskFANumber, InputMaskOfficeAccount, InputMaskOfficeFA } from '../../Helpers/Formatters/InputMaskClientAccount';
import { InputMaskDate, NumberFormatDecimal } from '../../Helpers/Formatters';
import { checkValidDate } from "../../Helpers/Dates/CompareDate";
import { emptyStringToUndefined } from '../../Helpers/Formatters/EmptyStringToUndefined';
import { isBefore, parse, sub } from 'date-fns';
import useUserInfo from '../../../hooks/useUserInfo';
import { retrieveAccountUserSetup } from '../../Product/SharedComponents/RetrieveAccount/Helpers';

const useStyles = makeStyles(theme => ({
  MuiAccordionroot: {
    "&.MuiAccordion-root:before": {
      backgroundColor: "#f7f7f7 "
    },
    boxShadow: '0px 2px 3px #00000029'
  },
}));
export default function CaseFilters(props) { 
  const { advisorList, filterUpdate, state, disabled, defaultState } = props;

  const [expanded, setExpanded] = useState(state.showFilter);
  const [filterObject, setFilterObject] = useState(state);
  const [faList, setFaList] = useState([]);
  const [officeList, setOfficeList] = useState([]);
  const [showDropDown, setShowDropDown] = useState(false);
  const { faOptions, role } = useUserInfo();

  const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
    validationSchema: CaseFilters.ValidationSchema(filterObject.createdDateStart, showDropDown, officeList.length),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const classes = useStyles();

  const onFieldChange = (field, value) => {
    let fullFilterObject = {};
    if (field === 'caseOrIllustration')
      fullFilterObject = { ...filterObject, [field]: value, 'IllustrationStatusCategory': '', 'caseStatus': '', showFilter: true };
    else if ((field === 'faNum' && filterObject.officeNum !== '') || (field === 'officeNum' && filterObject.faNum !== '')) {
      let officeFa = ""; 
      fullFilterObject = { ...filterObject, [field]: value, officeFa, showFilter: true };
    }
    else
      fullFilterObject = { ...filterObject, [field]: value, showFilter: true };
    setValue(field, value);
    triggerValidation(field);
    setFilterObject(fullFilterObject);
  }

  const submitFilters = () => {
    filterUpdate(filterObject);
  }

  const clearFilters = () => {
    filterUpdate(defaultState.filters);
  }

  const advisorOptions = advisorList.map((advisor) => {
    return {
      value: advisor.agentId,
      text: `${advisor.firstName} ${advisor.lastName}`
    };
  });

  useEffect(() => {
    retrieveAccountUserSetup(faOptions, role, setShowDropDown, setFaList, setOfficeList);
  }, [])

  useEffect(() => {
    register({ name: 'caseOrIllustration' });
    setValue('caseOrIllustration', filterObject.caseOrIllustration);

    register({ name: 'officeFa' });
    setValue('officeFa', filterObject.officeFa);

    register({ name: 'officeAccount' });
    setValue('officeAccount', filterObject.officeAccount);

    register({ name: 'branchOptions' });
    setValue('branchOptions', filterObject.branchOptions);

    register({ name: 'faNum' });
    setValue('faNum', filterObject.faNum);

    register({ name: 'officeNum' });
    setValue('officeNum', filterObject.officeNum);

    register({ name: 'referenceID' });
    setValue('referenceID', filterObject.referenceID);

    register({ name: 'ticketNumber' });
    setValue('ticketNumber', filterObject.ticketNumber);

    register({ name: 'createdDateStart' });
    setValue('createdDateStart', filterObject.createdDateStart);

    register({ name: 'createdDateEnd' });
    setValue('createdDateEnd', filterObject.createdDateEnd);

    register({ name: 'policy' });
    setValue('policy', filterObject.policy);

    register({ name: 'deathBenefitMin' });
    setValue('deathBenefitMin', filterObject.deathBenefitMin);

    register({ name: 'deathBenefitMax' });
    setValue('deathBenefitMax', filterObject.deathBenefitMax);

    register({ name: 'premiumAmountMin' });
    setValue('premiumAmountMin', filterObject.premiumAmountMin);

    register({ name: 'premiumAmountMax' });
    setValue('premiumAmountMax', filterObject.premiumAmountMax);

  }, [register]);

  const getBranchOptions = () => {
    if (faList.length === 0) {
      return [{ label: 'Input FA ID In My Branch', value: 'INPUT' }]
    }
    else {
      return [{ label: 'Input FA ID In My Branch', value: 'INPUT' }, { label: 'Select FA ID From Another Branch', value: 'SELECT' }]
    }
  }

  return (
    <Accordion expanded={expanded} className="filter-accordion" classes={{ root: classes.MuiAccordionroot }}>
      <AccordionSummary aria-controls={`filter-content`} id={`filter-header`}>
        <span onClick={() => setExpanded(!expanded)}>{expanded ? <ArrowDropDownIcon /> : <ArrowRightIcon />} Filters</span>
      </AccordionSummary>
      <Form onSubmit={handleSubmit(submitFilters)}>
        <AccordionDetails >
          <Row className='w-100'>
            <DropdownInput
              name="caseOrIllustration"
              id="caseOrIllustration"
              defaultValue={filterObject.caseOrIllustration}
              onChange={(e) => onFieldChange('caseOrIllustration', e.target.value)}
              errors={errors && errors.caseOrIllustration}
              label="Case or Illustration Request"
              variant="outlined"
              disabled={disabled}
              inputRef={register}
              colSize={3}
              menuItems={[
                { value: 'all', text: 'All' },
                { value: 'Insurance Case', text: 'Insurance Case' },
                { value: 'Insurance Illustration Request', text: 'Insurance Illustration Request' }
              ]}
            />
            {showDropDown ?
              <React.Fragment>
                {officeList.length > 0 &&
                  <DropdownInput
                    name="branchOptions"
                    id="branchOptions"
                    defaultValue={filterObject.branchOptions}
                    onChange={(e) => onFieldChange('branchOptions', e.target.value)}
                    errors={errors && errors.branchOptions}
                    label="How Would You Like to Proceed?"
                    variant="outlined"
                    disabled={disabled}
                    inputRef={register}
                    colSize={3}
                    menuItems={getBranchOptions()}
                  />
                }
                {
                  filterObject.branchOptions === 'INPUT' &&
                  <React.Fragment>
                    <DropdownInput
                      name="officeNum"
                      id="officeNum"
                      defaultValue={filterObject.officeNum}
                      onChange={(e) => onFieldChange('officeNum', e.target.value)}
                      errors={errors && errors.officeNum}
                      label="Office #"
                      variant="outlined"
                      disabled={disabled}
                      inputRef={register}
                      colSize={3}
                      menuItems={officeList}
                    />
                    <TextInput
                      name="faNum"
                      id="faNum"
                      defaultValue={filterObject.faNum}
                      onChange={(e) => onFieldChange('faNum', e.target.value)}
                      errors={errors && errors.faNum}
                      label="FA #"
                      variant="standard"
                      disabled={disabled}
                      inputRef={register}
                      colSize={3}
                      InputProps={{
                        inputComponent: InputMaskFANumber
                      }}
                    />
                  </React.Fragment>
                }
                {
                  (filterObject.branchOptions === 'SELECT' || officeList.length === 0) &&
                  <DropdownInput
                    name="officeFa"
                    id="officeFa"
                    defaultValue={filterObject.officeFa}
                    onChange={(e) => onFieldChange('officeFa', e.target.value)}
                    errors={errors && errors.officeFa}
                    label="Office-FA #"
                    variant="outlined"
                    disabled={disabled}
                    inputRef={register}
                    colSize={3}
                    menuItems={faList}
                  />
                }
              </React.Fragment>
              :
              <TextInput
                name="officeFa"
                id="officeFa"
                defaultValue={filterObject.officeFa}
                onChange={(e) => onFieldChange('officeFa', e.target.value)}
                errors={errors && errors.officeFa}
                label="Office-FA #"
                variant="standard"
                disabled={disabled}
                inputRef={register}
                colSize={3}
                InputProps={{
                  inputComponent: InputMaskOfficeFA
                }}
              />
            }

            {((showDropDown && (filterObject.branchOptions !== '' || officeList.length === 0)) || (!showDropDown)) &&
              <TextInput
                name="officeAccount"
                id="officeAccount"
                defaultValue={filterObject.officeAccount}
                onChange={(e) => onFieldChange('officeAccount', e.target.value)}
                errors={errors && errors.officeAccount}
                label="Office-Account #"
                variant="standard"
                disabled={disabled}
                inputRef={register}
                colSize={3}
                InputProps={{
                  inputComponent: InputMaskOfficeAccount
                }}
              />
            }

            <TextInput
              name="referenceID"
              id="referenceID"
              label="Reference ID"
              defaultValue={filterObject.referenceID}
              disabled={disabled}
              onChange={(e) => onFieldChange('referenceID', e.target.value, 40)}
              errors={errors && errors.referenceID}
              variant="standard"
              inputRef={register}
              colSize={3}
            />
            <TextInput
              name="ticketNumber"
              id="ticketNumber"
              label="Ticket #"
              defaultValue={filterObject.ticketNumber}
              disabled={disabled}
              onChange={(e) => onFieldChange('ticketNumber', e.target.value, 20)}
              errors={errors && errors.ticketNumber}
              variant="standard"
              inputRef={register}
              colSize={3}
            />
            {filterObject.caseOrIllustration !== 'Insurance Illustration Request' &&
              <DropdownInput
                name="caseStatus"
                id="caseStatus"
                defaultValue={filterObject.caseStatus}
                onChange={(e) => onFieldChange('caseStatus', e.target.value)}
                errors={errors && errors.caseStatus}
                label="Case Status Category"
                variant="outlined"
                disabled={disabled}
                inputRef={register}
                colSize={3}
                menuItems={[
                  { value: 'pending', text: 'Pending' },
                  { value: 'paid', text: 'Paid' },
                  { value: 'closed', text: 'Closed' },
                  { value: 'all', text: 'All' }
                ]}
              />
            }
            {filterObject.caseOrIllustration !== 'Insurance Case' &&
              <DropdownInput
                name="IllustrationStatusCategory"
                id="IllustrationStatusCategory"
                defaultValue={filterObject.IllustrationStatusCategory}
                onChange={(e) => onFieldChange('IllustrationStatusCategory', e.target.value)}
                errors={errors && errors.IllustrationStatusCategory}
                label="Illustration Status Category"
                variant="outlined"
                disabled={disabled}
                inputRef={register}
                colSize={3}
                menuItems={[
                  { value: 'Pending', text: 'Pending' },
                  { value: 'Complete', text: 'Complete' },
                  { value: 'all', text: 'All' }
                ]}
              />
            }
            <DropdownInput
              name="caseType"
              id="caseType"
              defaultValue={filterObject.caseType}
              onChange={(e) => onFieldChange('caseType', e.target.value)}
              errors={errors && errors.caseType}
              label="Case Type"
              variant="outlined"
              disabled={disabled}
              inputRef={register}
              colSize={3}
              menuItems={[
                { value: 'TERM', text: 'Term' },
                { value: 'LTC', text: 'LTC' },
                { value: 'PERM', text: 'Perm' },
                { value: 'DI', text: 'DI' },
                { value: 'all', text: 'All' }
              ]}
            />
            <TextInput
              name="createdDateStart"
              id="createdDateStart"
              value={filterObject.createdDateStart}
              onChange={(e) => onFieldChange('createdDateStart', e.target.value)}
              errors={errors && errors.createdDateStart}
              label="Submission Date (Start)"
              variant="standard"
              disabled={disabled}
              inputRef={register}
              colSize={3}
              InputProps={{
                inputComponent: InputMaskDate,
              }}
            />
            <TextInput
              name="createdDateEnd"
              id="createdDateEnd"
              value={filterObject.createdDateEnd}
              onChange={(e) => onFieldChange('createdDateEnd', e.target.value)}
              errors={errors && errors.createdDateEnd}
              label="Submission Date (End)"
              variant="standard"
              disabled={disabled}
              inputRef={register}
              InputProps={{
                inputComponent: InputMaskDate,
              }}
              colSize={3}
            />
            <TextInput
              name="carrier"
              id="carrier"
              defaultValue={filterObject.carrier}
              onChange={(e) => onFieldChange('carrier', e.target.value)}
              errors={errors && errors.carrier}
              label="Carrier"
              variant="standard"
              disabled={disabled}
              inputRef={register}
              colSize={3}
            />
            <TextInput
              name="plan"
              id="plan"
              defaultValue={filterObject.plan}
              onChange={(e) => onFieldChange('plan', e.target.value)}
              errors={errors && errors.plan}
              label="Plan"
              variant="standard"
              disabled={disabled}
              inputRef={register}
              colSize={3}
            />
            <TextInput
              name="policy"
              id="policy"
              defaultValue={filterObject.policy}
              onChange={(e) => onFieldChange('policy', e.target.value, 50)}
              errors={errors && errors.policy}
              label="Policy #"
              variant="standard"
              disabled={disabled}
              inputRef={register}
              colSize={3}
            />
            <TextInput
              name="firstName"
              id="firstName"
              defaultValue={filterObject.firstName}
              onChange={(e) => onFieldChange('firstName', e.target.value)}
              errors={errors && errors.firstName}
              label="Client First Name"
              variant="standard"
              disabled={disabled}
              inputRef={register}
              colSize={3}
            />
            <TextInput
              name="lastName"
              id="lastName"
              defaultValue={filterObject.lastName}
              onChange={(e) => onFieldChange('lastName', e.target.value)}
              errors={errors && errors.lastName}
              label="Client Last Name"
              variant="standard"
              disabled={disabled}
              inputRef={register}
              colSize={3}
            />
            <Col sm={3}>
              <AutocompleteInput
                name="advisor"
                id="advisor"
                defaultValue={advisorOptions && advisorOptions.length > 0 ? advisorOptions[0] : ''}
                onChange={(val) => onFieldChange('advisor', val)}
                errors={errors && errors.advisor}
                label="Select Advisor"
                variant="standard"
                disabled={disabled || advisorOptions.length === 0}
                inputRef={register}
                colSize={3}
                selectOptions={advisorOptions ? advisorOptions : []}
              />
            </Col>
            <DropdownInput
              name="residentState"
              id="residentState"
              defaultValue={filterObject.residentState}
              onChange={(e) => onFieldChange('residentState', e.target.value)}
              errors={errors && errors.residentState}
              label="Resident State"
              variant="standard"
              disabled={disabled}
              inputRef={register}
              colSize={3}
              menuItems={States()}
            />
            <TextInput
              name="deathBenefitMin"
              id="deathBenefitMin"
              label="Death Benefit Minimum"
              defaultValue={filterObject.deathBenefitMin}
              onChange={(e) => onFieldChange('deathBenefitMin', e.target.value, 13)}
              errors={errors && errors.deathBenefitMin}
              variant="standard"
              inputRef={register}
              InputProps={{
                inputComponent: NumberFormatDecimal,
              }}
              colSize={3}
            />
            <TextInput
              name="deathBenefitMax"
              id="deathBenefitMax"
              label="Death Benefit Maximum"
              defaultValue={filterObject.deathBenefitMax}
              onChange={(e) => onFieldChange('deathBenefitMax', e.target.value, 13)}
              errors={errors && errors.deathBenefitMax}
              variant="standard"
              inputRef={register}
              InputProps={{
                inputComponent: NumberFormatDecimal,
              }}
              colSize={3}
            />
            <TextInput
              name="premiumAmountMin"
              id="premiumAmountMin"
              label="Premium Amount Minimum"
              defaultValue={filterObject.premiumAmountMin}
              onChange={(e) => onFieldChange('premiumAmountMin', e.target.value, 13)}
              errors={errors && errors.premiumAmountMin}
              variant="standard"
              inputRef={register}
              InputProps={{
                inputComponent: NumberFormatDecimal,
              }}
              colSize={3}
            />
            <TextInput
              name="premiumAmountMax"
              id="premiumAmountMax"
              label="Premium Amount Maximum"
              defaultValue={filterObject.premiumAmountMax}
              onChange={(e) => onFieldChange('premiumAmountMax', e.target.value, 13)}
              errors={errors && errors.premiumAmountMax}
              variant="standard"
              inputRef={register}
              InputProps={{
                inputComponent: NumberFormatDecimal,
              }}
              colSize={3}
            />
            <DropdownInput
              name="reg60"
              id="reg60"
              defaultValue={filterObject.reg60}
              onChange={(e) => onFieldChange('reg60', e.target.value)}
              errors={errors && errors.reg60}
              label="Reg 60"
              variant="outlined"
              disabled={disabled}
              inputRef={register}
              colSize={3}
              menuItems={[
                { value: 'Yes', text: 'Yes' },
                { value: 'No', text: 'No' },
              ]}
            />
            <DropdownInput
              name="esign"
              id="esign"
              defaultValue={filterObject.esign}
              onChange={(e) => onFieldChange('esign', e.target.value)}
              errors={errors && errors.esign}
              label="ESign"
              variant="outlined"
              disabled={disabled}
              inputRef={register}
              colSize={3}
              menuItems={[
                { value: 'Yes', text: 'Yes' },
                { value: 'No', text: 'No' },
              ]}
            />
            <DropdownInput
              name="replacement"
              id="replacement"
              defaultValue={filterObject.replacement}
              onChange={(e) => onFieldChange('replacement', e.target.value)}
              errors={errors && errors.replacement}
              label="Replacement"
              variant="outlined"
              disabled={disabled}
              inputRef={register}
              colSize={3}
              menuItems={[
                { value: 'Yes', text: 'Yes' },
                { value: 'No', text: 'No' },
              ]}
            />
          </Row>
        </AccordionDetails>
        <Row className="pt-2 mb-4 mx-2">
          <Col className="text-left button-back">
            <Button variant="contained" size="medium" color="primary" onClick={clearFilters} >CLEAR FILTERS</Button>
            <Button className='ml-3' variant="contained" size="medium" color="primary" type="submit" >SEARCH</Button>
          </Col>
        </Row>
      </Form>
    </Accordion>
  )
}

CaseFilters.propTypes = {
  filterUpdate: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired
}

CaseFilters.ValidationSchema = (startDate, showDropDown = false, officeLength) => {
  return yup.object().shape({
    caseOrIllustration: yup.string().required("Case Or Illustration is required."),
    officeAccount: customValidators.string().isValidFAAccount('Invalid Office-Account #. 3 digit Office # must be between 001 and 999. 6 digit Account # must be between 000001 and 999999.', 9, false),
    faNum: yup.string().when('branchOptions', {
      is: (branchOptions) => branchOptions === 'INPUT',
      then: customValidators.string().required('Office FA is required.').isValidOfficeFA('Invalid FA #. 3 digit FA # must be between 001 and 999.', 3, true, true),
      otherwise: yup.string().notRequired(),
    }),
    officeNum: yup.string().when('branchOptions', {
      is: (branchOptions) => branchOptions === 'INPUT',
      then: yup.string().required('This field is required'),
      otherwise: yup.string().notRequired(),
    }),
    officeFa: yup.string().when(['branchOptions'], {
      is: (branchOptions) => ((showDropDown && (branchOptions === 'SELECT' || officeLength === 0))),
      then: customValidators.string().required('Office FA is required.').isValidOfficeFA('Invalid Office-FA #. 3 digit Office # must be between 001 and 999. 3 digit FA # must be between 001 and 999.', 7),
      otherwise: customValidators.string().notRequired().isValidOfficeFA('Invalid Office-FA #. 3 digit Office # must be between 001 and 999. 3 digit FA # must be between 001 and 999.', 7, false, false),
    }),
    referenceID: yup.string().max(40, 'Maximum 40 characters allowed.'),
    ticketNumber: yup.string().matches(/^[a-zA-Z0-9]{1,20}$/, 'Only numbers or alphabets of length 20 is allowed.').transform(emptyStringToUndefined),
    createdDateStart: yup.date().typeError('Invalid date.').transform(emptyStringToUndefined).notRequired(),
    createdDateEnd: checkValidDate(startDate) ?
      yup.date().typeError('Invalid date.')
        .min(new Date(startDate), `Submission Date (End) date cannot be before Submission Date (Start) date.`).transform(emptyStringToUndefined).notRequired()
      : yup.date().typeError('Invalid date.').transform(emptyStringToUndefined).notRequired(),
    policy: yup.string().matches(/^[a-zA-Z0-9]{1,50}$/, 'Only numbers or alphabets of length 50 is allowed.').transform(emptyStringToUndefined),
    deathBenefitMin: yup.string().max(13, 'Maximum 13 characters allowed.').nullable(),
    deathBenefitMax: yup.string().max(13, 'Maximum 13 characters allowed.').nullable(),
    premiumAmountMin: yup.string().max(13, 'Maximum 13 characters allowed.').nullable(),
    premiumAmountMax: yup.string().max(13, 'Maximum 13 characters allowed.').nullable(),
  })
}


// WEBPACK FOOTER //
// ./src/components/ActivityCenter/SubComponents/CaseFilters.js